import {Typography} from '@mui/material';
import {OptionNode} from '../components/common/aur-select/AurSelect';
import {t} from 'i18next';
import {FieldFilterGridData} from '../components/pages/field-management/field-table/FieldPopoverGridFilter';

export enum FieldDropDownType {
  Text = 'Text',
  Integer = 'Integer',
  DateTime = 'DateTime',
  Date = 'Date',
  Time = 'Time',
  Float = 'Float',
}

export const getCustomMetaDataList = (): OptionNode[] => {
  return [
    {
      key: FieldDropDownType.Text,
      value: FieldDropDownType.Text,
      label: t('customMetaData.text'),
    },
    {
      key: FieldDropDownType.Integer,
      value: FieldDropDownType.Integer,
      label: t('customMetaData.number'),
    },
    {
      key: FieldDropDownType.DateTime,
      value: FieldDropDownType.DateTime,
      label: (
        <>
          {' '}
          {t('customMetaData.dateTime')}{' '}
          <Typography
            component="span"
            className="typo-text body3_size color-mist-700"
          >
            (YYYY/MM/DD HH:MM:SS)
          </Typography>
        </>
      ),
    },
    {
      key: FieldDropDownType.Date,
      value: FieldDropDownType.Date,
      label: (
        <>
          {' '}
          {t('customMetaData.date')}{' '}
          <Typography
            component="span"
            className="typo-text body3_size color-mist-700"
          >
            (YYYY/MM/DD)
          </Typography>
        </>
      ),
    },
    {
      key: FieldDropDownType.Time,
      value: FieldDropDownType.Time,
      label: (
        <>
          {' '}
          {t('customMetaData.time')}{' '}
          <Typography
            component="span"
            className="typo-text body3_size color-mist-700"
          >
            (HH:MM:SS)
          </Typography>
        </>
      ),
    },
  ];
};

export const getNumberTypeList = (): OptionNode[] => {
  return [
    {
      key: FieldDropDownType.Integer,
      value: FieldDropDownType.Integer,
      label: t('customMetaData.integer'),
    },
    {
      key: FieldDropDownType.Float,
      value: FieldDropDownType.Float,
      label: (
        <>
          {t('customMetaData.float')}{' '}
          <Typography
            component="span"
            className="typo-text body3_size color-mist-700"
          >
            (Rounded to 5 decimals)
          </Typography>
        </>
      ),
    },
  ];
};

export const getFieldCategoryList = (): FieldFilterGridData[] => {
  return [
    {
      id: 1,
      label: t('fieldCategory.standardMetadata'),
    },
    {
      id: 2,
      label: t('fieldCategory.customMetadata'),
    },
    {
      id: 3,
      label: t('fieldCategory.tagField'),
    },
    {
      id: 4,
      label: t('fieldCategory.export'),
    },
    {
      id: 5,
      label: t('fieldCategory.str'),
    },
    {
      id: 6,
      label: t('fieldCategory.none'),
    },
  ];
};
